import { Component, OnInit } from '@angular/core';
import {MobileContainerComponent} from "../mobile-container/mobile-container.component";

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['../mobile-container/mobile-container.component.scss']
})
export class TopMenuComponent implements OnInit {

  constructor(public mobileContainer:MobileContainerComponent) {
  }

  ngOnInit(): void {
  }

}
